import store from "@/config/vuex/store";

export default [
    {
        path: "/niveis-acesso",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "niveis_acessoRead",
                component: () => import('@/pages/NiveisAcesso/NiveisAcessoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "niveis_acessoCreate",
                component: () => import('@/pages/NiveisAcesso/NiveisAcessoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "niveis_acessoUpdate",
                component: () => import('@/pages/NiveisAcesso/NiveisAcessoUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },            
            {
                path: "permissoes/:id",
                name: "niveis_acessoReadPermissao",
                component: () => import('@/pages/NiveisAcesso/NiveisAcessoReadPermissoes'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

